export default __webpack_public_path__ + "static/agbiome-bf6607f97cc2d109d1dd740b035a2383.png";